import cn from "../../../lib/cn";

/** Admin-panel screenshot in a slim dark bezel (the admin UI is dark). */
export const ScreenFrame = ({
  src,
  alt,
  width,
  height,
  className,
  eager,
}: {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  eager?: boolean;
}) => (
  <div
    className={cn(
      "rounded-2xl bg-[#0b1220] p-1.5 shadow-[0_30px_60px_-30px_rgba(15,23,42,0.45)] ring-1 ring-gray-900/10",
      className,
    )}
  >
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className="block h-auto w-full rounded-[11px]"
    />
  </div>
);

/**
 * Employee-app screenshot in a phone bezel. Corner radius and bezel scale
 * with the phone's width (container units), so small phones aren't over-rounded.
 */
export const PhoneFrame = ({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className?: string;
}) => (
  <div className={cn("[container-type:inline-size]", className)}>
    <div className="rounded-[15cqw] bg-gray-900 p-[3.2cqw] shadow-[0_24px_50px_-24px_rgba(15,23,42,0.5)] ring-1 ring-gray-900/20">
      <img
        src={src}
        alt={alt}
        width={600}
        height={1299}
        loading="lazy"
        decoding="async"
        className="block h-auto w-full rounded-[12cqw] bg-white"
      />
    </div>
  </div>
);
